module.exports = __webpack_public_path__ + "static/scale-model-of-plano-texas-ef243200ad1acfb4854a72cd8ccf03a9.png";